import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, Facebook, Twitter, Linkedin, Youtube } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#1e3428] text-white">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {/* Column 1: Logo & About */}
          <div className="space-y-4">
            <Link
              to="/"
              className="inline-flex items-center"
              data-testid="footer-logo"
            >
              <img
                src={process.env.PUBLIC_URL + "/logo header.png"}
                alt="Reliable Exports"
                className="h-8 md:h-9 w-auto object-contain brightness-0 invert"
              />
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed max-w-xs">
              Reliable Exports specializes in manufacturing and exporting
              high-quality eco-friendly bags, combining traditional
              craftsmanship with modern production standards.
            </p>
            <div className="flex gap-3 pt-4">
              <a
                href="#"
                data-testid="social-facebook"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-sand transition-colors"
              >
                <Facebook className="w-4 h-4" />
              </a>
              <a
                href="#"
                data-testid="social-twitter"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-sand transition-colors"
              >
                <Twitter className="w-4 h-4" />
              </a>
              <a
                href="#"
                data-testid="social-linkedin"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-sand transition-colors"
              >
                <Linkedin className="w-4 h-4" />
              </a>
              <a
                href="#"
                data-testid="social-youtube"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-sand transition-colors"
              >
                <Youtube className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="space-y-4">
            <h4 className="font-semibold text-sand tracking-wide">
              Quick Links
            </h4>
            <div className="flex flex-col gap-2">
              <Link
                to="/"
                data-testid="footer-home"
                className="text-gray-400 text-sm hover:text-sand transition-colors"
              >
                Home
              </Link>
              <Link
                to="/about"
                data-testid="footer-about"
                className="text-gray-400 text-sm hover:text-sand transition-colors"
              >
                About
              </Link>
              <Link
                to="/products"
                data-testid="footer-products"
                className="text-gray-400 text-sm hover:text-sand transition-colors"
              >
                Collections
              </Link>
              <Link
                to="/manufacturing"
                data-testid="footer-manufacturing"
                className="text-gray-400 text-sm hover:text-sand transition-colors"
              >
                Manufacturing
              </Link>
              <Link
                to="/contact"
                data-testid="footer-contact"
                className="text-gray-400 text-sm hover:text-sand transition-colors"
              >
                Contact
              </Link>
            </div>
          </div>

          {/* Column 3: Contact Information */}
          <div className="space-y-4">
            <h4 className="font-semibold text-sand tracking-wide">
              Contact Information
            </h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-sand mt-1 flex-shrink-0" />
                <div>
                  <h5 className="text-sm font-medium text-white mb-1">Phone</h5>
                  <p className="text-gray-400 text-sm leading-relaxed">
                    <a
                      href="tel:+12134712170"
                      data-testid="footer-phone"
                      className="hover:text-sand transition-colors"
                    >
                      USA TEL : 213 - 471 - 2170
                    </a>
                    <br />
                    <a
                      href="tel:+911141448168"
                      className="hover:text-sand transition-colors"
                    >
                      India Tel : +91 11 - 41448168
                    </a>
                    <br />
                    <span>
                      Cell -{" "}
                      <a
                        href="tel:+919910299995"
                        className="hover:text-sand transition-colors"
                      >
                        +91 9910299995
                      </a>
                      {", "}
                      <a
                        href="tel:+919810272098"
                        className="hover:text-sand transition-colors"
                      >
                        9810272098
                      </a>
                    </span>
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-sand mt-1 flex-shrink-0" />
                <div>
                  <h5 className="text-sm font-medium text-white mb-1">Email</h5>
                  <a
                    href="mailto:amit@reliableexports.in"
                    data-testid="footer-email"
                    className="text-gray-400 text-sm hover:text-sand transition-colors"
                  >
                    amit@reliableexports.in
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Column 4: Our Address */}
          <div className="space-y-4">
            <h4 className="font-semibold text-sand tracking-wide">
              Our Address
            </h4>
            <div className="space-y-4 text-gray-400 text-sm leading-relaxed">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-sand mt-1 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-white mb-1">USA Address</p>
                  <p>
                    Reliable Exports
                    <br />
                    10430 Montgomery Ave
                    <br />
                    Granada Hills, CA 91344, USA
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-sand mt-1 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-white mb-1">India Offices</p>
                  <p>
                    <span className="font-semibold text-white">
                      Registered office -
                    </span>
                    <br />
                    5, Gujrawala Town - II
                    <br />
                    Delhi - 110009, India
                    <br />
                    <br />
                    <span className="font-semibold text-white">
                      Manufacturing -
                    </span>
                    <br />
                    C 106, Mayapuri Industrial Area, Phase - 2
                    <br />
                    Delhi - 110064, India
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 text-center text-gray-400 text-sm">
          <p>© {new Date().getFullYear()} Reliable Exports Pvt Ltd. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
